document.body.addEventListener('click', function (e) {
  const target = e.target.closest('[data-action="save"]');
  if (!target) return;

  
  const form = document.querySelector('.product-form__buy-buttons form[action="/cart/add"]');
  if (!form) return;

  
  // Remove existing property div
  const existingPropertyDiv = form.querySelector('.propertydiv');
  if (existingPropertyDiv) {
    existingPropertyDiv.remove();
  }
  
  // Collect input values
  let html = '';
  const container = document.querySelector('#customModal');
  if (container) {
    const fields = container.querySelectorAll('input[type="text"], textarea, input[type="number"]');
    
    fields.forEach(function (field) {
      const name = field.getAttribute('name');
      const value = field.value;
      if (name) {
        html += `<input type="hidden" name="${name}" value="${value}">`;
      }
    });
  }

  // Append hidden inputs
  const wrapper = document.createElement('div');
  wrapper.className = 'propertydiv';
  wrapper.style.display = 'none';
  wrapper.innerHTML = html;
  form.appendChild(wrapper);


  // Trigger submit button click
  const submitBtn = form.querySelector('#AddToCart');
  if (submitBtn) {
    submitBtn.removeAttribute('disabled');
    submitBtn.click();
  }

  // Remove body class
  document.body.classList.remove('measurement-show');

  // Trigger first size radio
  const firstSizeRadio = document.querySelector('input[type="radio"][name="Size"]');
  if (firstSizeRadio) {
    firstSizeRadio.click();
  }

  // Remove property div again
  const propertyDivAfter = form.querySelector('.propertydiv');
  if (propertyDivAfter) {
    propertyDivAfter.remove();
  }
  
});


(function () {


let measurementCompleted = false;


  const MODAL_SELECTOR = '#customModal';
  const RADIO_SELECTOR = '.block-swatch__radio';

  let openedRadio = null;
  let modal = null;
  let currentStep = 0;
  let steps = [];

  const $  = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from((root || document).querySelectorAll(sel));

  /* ---------- Validation helpers ---------- */
function setFieldError(input, msg) {
  if (!input) return;

  const stepEl = steps[currentStep];
  const errorEl = stepEl.querySelector(`[data-error-for="${input.id}"]`);

  if (errorEl) errorEl.textContent = msg || '';
}


  function validateInput(input) {
    if (!input) return true;
    if (input.id === 'reviewNote') { setFieldError(input, ''); return true; }
    const raw = (input.value ?? '').trim();
    if (raw === '') { setFieldError(input, 'This field is required.'); return false; }
    if (input.type === 'number') {
      const num = Number(raw);
      if (!Number.isFinite(num)) { setFieldError(input, 'Enter a valid number.'); return false; }
      const min = input.hasAttribute('min') ? Number(input.getAttribute('min')) : -Infinity;
      const max = input.hasAttribute('max') ? Number(input.getAttribute('max')) : Infinity;
      if (num < min) { setFieldError(input, `Minimum is ${min}.`); return false; }
      if (num > max) { setFieldError(input, `Maximum is ${max}.`); return false; }
    }
    setFieldError(input, '');
    return true;
  }

  function clampNumberOnBlur(input) {
    if (!input || input.type !== 'number') return;
    if ((input.value ?? '').trim() === '') return;
    const min = input.hasAttribute('min') ? Number(input.getAttribute('min')) : -Infinity;
    const max = input.hasAttribute('max') ? Number(input.getAttribute('max')) : Infinity;
    let n = Number(input.value);
    if (n < min) n = min;
    if (n > max) n = max;
    input.value = String(n);
  }

  /* ---------- Step validation logic ---------- */
  function isStepValid(stepEl) {
    if (!stepEl) return true;
    if (stepEl.getAttribute('data-step') === '1') return true;
    if (stepEl.dataset.role === 'summary') return true;
    const inputs = $$('input', stepEl);
    if (inputs.length === 0) return true;
    let ok = true;
    for (let i = 0; i < inputs.length; i++) {
      const inp = inputs[i];
      if (!validateInput(inp)) ok = false;
    }
    return ok;
  }

  function areAllDataStepsValid() {
    if (!steps || steps.length === 0) return true;
    const dataSteps = steps.filter(s => {
      if (s.getAttribute('data-step') === '1') return false;
      if (s.dataset.role === 'review' || s.dataset.role === 'summary') return false;
      return true;
    });
    return dataSteps.every(isStepValid);
  }

  /* ---------- UI control ---------- */
  function updateButtonsForStep() {
    const stepEl = steps[currentStep];
    if (!stepEl) return;
    const prevBtn = $('[data-action="prev"]', stepEl);
    const nextBtn = $('[data-action="next"]', stepEl);
    const saveBtn = $('[data-action="save"]', stepEl);

    if (prevBtn) prevBtn.disabled = currentStep === 0;
    // if (nextBtn) nextBtn.disabled = !isStepValid(stepEl);
    if (nextBtn) nextBtn.disabled = false;
    if (saveBtn) saveBtn.disabled = !areAllDataStepsValid();
  }

  function showStep(idx) {
    if (!steps || steps.length === 0) return;
    currentStep = Math.max(0, Math.min(idx, steps.length - 1));

    steps.forEach((s, i) => {
      const active = i === currentStep;
      s.hidden = !active;

      // video lazy load/unload
      const vid = s.querySelector('video');
      if (vid) {
        if (active) {
          if (!vid.src) vid.src = vid.dataset.src;
          vid.play().catch(()=>{});
        } else {
          vid.pause();
          vid.removeAttribute('src');
          try { vid.load(); } catch(_) {}
        }
      }
    });

 const activeEl = steps[currentStep];

setTimeout(() => {
  // Skip intro step
  if (activeEl.getAttribute('data-step') === '1') return;

  // If review step → focus textarea
  if (activeEl.dataset.role === 'review') {
    activeEl.querySelector('textarea')?.focus();
    return;
  }

  // If summary step → do nothing
  if (activeEl.dataset.role === 'summary') return;

  // Otherwise focus first number/text input
  const firstInput = activeEl.querySelector('input[type="number"], input[type="text"]');
  if (firstInput) {
    firstInput.focus();
    firstInput.select(); // optional: auto select value
  }
}, 50);

    if (activeEl?.dataset.role === 'summary') {
      populateSummary(activeEl);
    }

    updateButtonsForStep();
    updateProgressBar();
  }

  function onBackdropClick(e) {
    if (e.target === e.currentTarget) closeModal(false);
  }

// function resetAllFields() {
//   if (!steps || !modal) return;

//   steps.forEach(step => {

//     step.querySelectorAll('input, textarea').forEach(inp => {

//       if (inp.disabled) return;

//       if (inp.type === 'checkbox' || inp.type === 'radio') {
//         inp.checked = false;
//       } else {
//         inp.value = '';
//       }

//       const err = modal.querySelector(`[data-error-for="${inp.id}"]`);
//       if (err) err.textContent = '';
//     });

//   });
// }


  function openModal(forRadio = null) {
    
         
    modal = $(MODAL_SELECTOR);
    if (!modal) return;
    openedRadio = forRadio;

    steps = $$('.modal__step', modal);
    $$('[data-error-for]', modal).forEach(el => el.textContent = '');

    if (!modal._wired) {
      modal.addEventListener('click', (e) => {
        if (e.target.closest('[data-close]')) { e.preventDefault(); closeModal(false); return; }

        const btn = e.target.closest('[data-action]') || e.target.closest('[data-goto]');
        if (!btn) return;

        const action = btn.getAttribute('data-action');
        if (action === 'prev') {
          showStep(currentStep - 1);
          steps[currentStep].querySelector('input,button')?.focus();
          return;
        }

        if (action === 'next') {

  const stepEl = steps[currentStep];
  const inputs = $$('input, textarea', stepEl);

  let valid = true;
  let firstInvalid = null;

  inputs.forEach(inp => {

    // 🚀 Skip validation for reviewNote
  if (inp.id === 'reviewNote') {
    setFieldError(inp, '');
    return;
  }

    const raw = (inp.value ?? '').trim();

    if (raw === '') {
      setFieldError(inp, 'This field is required.');
      valid = false;
      if (!firstInvalid) firstInvalid = inp;
      return;
    }

    if (inp.type === 'number') {
      const value = Number(raw);
      const min = inp.hasAttribute('min') ? Number(inp.getAttribute('min')) : null;
      const max = inp.hasAttribute('max') ? Number(inp.getAttribute('max')) : null;

      if (!Number.isFinite(value)) {
        setFieldError(inp, 'Please enter a valid number.');
        valid = false;
        if (!firstInvalid) firstInvalid = inp;
        return;
      }
     if (min !== null && max !== null && (value < min || value > max)) {
  setFieldError(inp, `Please input value between ${min} and ${max}.`);
  valid = false;
  if (!firstInvalid) firstInvalid = inp;

  return;
}

    }

    setFieldError(inp, '');
  });

  if (!valid) {
    if (firstInvalid) firstInvalid.focus();
    return; // 🚫 STOP HERE — DO NOT GO TO NEXT STEP
  }

  showStep(currentStep + 1);
  return;
}


        if (action === 'save') {
          if (areAllDataStepsValid()) {

            // copy modal inputs into product form
            copyModalValuesToProductForm();
            if (openedRadio) {
              try { openedRadio.checked = true; openedRadio.dispatchEvent(new Event('change', { bubbles: true })); } catch(_) {}
            }
            measurementCompleted = true;


            

            setTimeout(() => {
          selectDefaultSize();
        }, 0);

            closeModal(true);
          } else {
            const badIdx = steps.findIndex(s => !isStepValid(s));
            if (badIdx >= 0) showStep(badIdx);
          }
          return;
        }


        if (btn.hasAttribute('data-goto')) {
          const gotoIdx = Number(btn.getAttribute('data-goto'));
          if (!Number.isNaN(gotoIdx)) {
            showStep(gotoIdx);
            setTimeout(() => {
              steps[gotoIdx].querySelector('input,button')?.focus();
            }, 0);
          }
          return;
        }
      });

    //   modal.addEventListener('input', (e) => {
    //     if (!steps[currentStep]?.contains(e.target)) return;
    //     if (e.target instanceof HTMLElement) validateInput(e.target);
    //     updateButtonsForStep();
    //   });

    //   modal.addEventListener('change', (e) => {
    //     if (!steps[currentStep]?.contains(e.target)) return;
    //     if (e.target instanceof HTMLElement) validateInput(e.target);
    //     updateButtonsForStep();
    //   });

    //   modal.addEventListener('blur', (e) => {
    //     const t = e.target;
    //     if (t instanceof HTMLInputElement) {
    //       clampNumberOnBlur(t);
    //       validateInput(t);
    //       updateButtonsForStep();
    //  updateProgressBar();

    //     }
    //   }, true);

      modal._wired = true;
    }

    modal.hidden = false;
    modal.addEventListener('click', onBackdropClick);
    if (!measurementCompleted) {
  // resetAllFields();
  showStep(0);

} else {
  const summaryIndex = steps.findIndex(s => s.dataset.role === 'summary');
  if (summaryIndex >= 0) {
    showStep(summaryIndex);
  } else {
    showStep(0);
  }
}

updateProgressBar();

    (steps[0]?.querySelector('input,button') || $('[data-close]', modal))?.focus();
  }

function closeModal(finalized = true) {
  modal = $(MODAL_SELECTOR);
  if (!modal) return;

  modal.hidden = true;
  modal.removeEventListener('click', onBackdropClick);

  if (!finalized) {
    // only reset if NOT finalized
    // resetAllFields();
    const bar = document.getElementById('progress-bar');
    if (bar) bar.style.width = '0%';
  }

   if (!finalized) {
    selectDefaultSize();
  }


  openedRadio = null;
}


  /* ---------- Summary population ---------- */
  function readStepValues(stepEl) {
    const inputs = $$('input', stepEl);
    if (inputs.length === 0) {
      const text = stepEl.querySelector('p')?.textContent?.trim() || '';
      return text ? [{ label: 'Info', value: text }] : [];
    }
    return inputs.map(inp => {
      const label = stepEl.querySelector(`label[for="${inp.id}"]`)?.textContent?.trim() || inp.name;
      const value = (inp.type === 'checkbox' || inp.type === 'radio') ? (inp.checked ? 'Yes' : 'No') : (inp.value ?? '').trim() || '(empty)';
      return { label, value };
    });
  }

  // function populateSummary(summaryEl) {
  //   const list = summaryEl.querySelector('.summary-list');
  //   if (!list) return;
  //   list.innerHTML = '';

  //   steps.forEach((s, idx) => {
  //     if (s.getAttribute('data-step') === '1') return;
  //     if (s.dataset.role === 'summary') return;

  //     const values = readStepValues(s);
  //     const entry = document.createElement('div');
  //     entry.className = 'summary-entry';
  //     entry.style = 'padding:5px 0; display: flex; justify-content: space-between;';

  //     const titleText = s.querySelector('h3')?.textContent?.trim() || s.querySelector('h2')?.textContent?.trim() || `Step ${idx+1}`;
  //     const h = document.createElement('strong');
  //     h.textContent = titleText;
  //     entry.appendChild(h);

  //     if (values.length === 0) {
  //       const p = document.createElement('p');
  //       p.textContent = '(no fields)';
  //       entry.appendChild(p);
  //     } else {
  //       const ul = document.createElement('ul');
  //       ul.style = 'margin:8px 0 0 16px;padding:0';
  //       values.forEach(v => {
  //         const li = document.createElement('li');
  //         li.textContent = `${v.label}: ${v.value}`;
  //         ul.appendChild(li);
  //       });
  //       entry.appendChild(ul);
  //     }

  //     const edit = document.createElement('div');
  //     entry.className = 'edit_button';
  //     // edit.type = 'button';
  //     edit.textContent = 'Edit';
  //     edit.setAttribute('data-goto', String(idx));
  //     edit.style = 'margin-left:12px; cursor: pointer;';
  //     entry.appendChild(edit);

  //     list.appendChild(entry);
  //   });

  //   const saveBtn = summaryEl.querySelector('[data-action="save"]');
  //   if (saveBtn) saveBtn.disabled = !areAllDataStepsValid();
  // }



// function populateSummary(summaryEl) {
//   const list = summaryEl.querySelector('.summary-list');
//   if (!list) return;
//   list.innerHTML = '';

//   let displayIndex = 1; // start counting from 1
//   steps.forEach((s, idx) => {
//     const stepNum = s.getAttribute('data-step');
//     if (!stepNum || stepNum === '1') return; // skip intro
//     if (s.dataset.role === 'summary') return;

//     const values = readStepValues(s);
//     if (!values.length) return;

//     // Create wrapper row
//     const row = document.createElement('div');
//     row.className = 'summary-row';
//     row.style = `
//       display: flex;
//       align-items: center;
//       justify-content: space-between;
//       padding: 5px 8px;
//       font-size: 14px;
//     `;

//     // Display index (starts from 1)
//     const stepIndex = document.createElement('span');
//     stepIndex.textContent = `${displayIndex++}.`; // increment after each step
//     stepIndex.style = 'width: 24px; font-weight: 600; text-align: center;';
//     row.appendChild(stepIndex);

//     // Label + value container
//     const labelValWrap = document.createElement('div');
//     labelValWrap.style = 'flex: 1; display: flex; justify-content: space-between; align-items: center; gap: 10px;';

//     const label = document.createElement('span');
//     label.textContent = s.querySelector('h3')?.textContent?.trim() || `Step ${stepNum}`;
//     label.style = 'font-weight: 500; flex: 1;';
//     labelValWrap.appendChild(label);

//     const value = document.createElement('span');
//     value.textContent = values[0]?.value || '(empty)';
//     value.style = 'color: #333; min-width: 60px; text-align: right;';
//     labelValWrap.appendChild(value);

//     row.appendChild(labelValWrap);

//     // Edit button
//     const edit = document.createElement('div');
//     edit.textContent = 'Edit';
//     edit.setAttribute('data-goto', String(idx));
//     edit.className = 'edit_button';
//     edit.style = `
//       margin-left: 10px;
//       padding: 0px 8px;
//       cursor: pointer;
//     `;
//     row.appendChild(edit);

//     list.appendChild(row);
//   });


//   const reviewInput = modal.querySelector('#reviewNote');
//   if (reviewInput && reviewInput.value.trim() !== '') {
//     const index = list.children.length + 1; // numbered index
//     const row = document.createElement('div');
//     row.className = 'summary-row';
//     row.dataset.step = 'review'; // track which step it belongs to
//     row.style = `
//       display: flex;
//       justify-content: space-between;
//       align-items: center;
//       padding: 6px 8px;
//       font-size: 14px;
//       border-bottom: 1px solid #eee;
//     `;

//     const left = document.createElement('span');
//     left.textContent = `${index}. Review Note`;
//     left.style = 'font-weight: 500;';
//     row.appendChild(left);

//     const right = document.createElement('span');
//     right.style = 'display:flex; gap:8px; align-items:center;';

//     const value = document.createElement('span');
//     value.textContent = reviewInput.value.trim();
//     value.style.color = '#333';
//     right.appendChild(value);

//     const editBtn = document.createElement('button');
//     editBtn.type = 'button';
//     editBtn.textContent = 'Edit';
//     editBtn.style = `
//       background: #eee;
//       border: none;
//       padding: 2px 6px;
//       border-radius: 4px;
//       cursor: pointer;
//       font-size: 12px;
//     `;
//     edit.addEventListener('click', () => {
//       const reviewStepIdx = steps.findIndex(s => s.dataset.role === 'review');
//       if (reviewStepIdx >= 0) showStep(reviewStepIdx);
//     });
//     right.appendChild(editBtn);

//     row.appendChild(right);
//     list.appendChild(row);
//   }
  


//   // Enable save only if all steps are valid
//   const saveBtn = summaryEl.querySelector('[data-action="save"]');
//   if (saveBtn) saveBtn.disabled = !areAllDataStepsValid();
// }

function populateSummary(summaryEl) {
  const list = summaryEl.querySelector('.summary-list');
  if (!list) return;
  list.innerHTML = '';

  let displayIndex = 1; // start counting from 1

  steps.forEach((s, idx) => {
    const stepNum = s.getAttribute('data-step');
    if (!stepNum || stepNum === '1') return; // skip intro
    if (s.dataset.role === 'summary') return;

    const values = readStepValues(s);
    if (!values.length) return; 

    // Create wrapper row
    const row = document.createElement('div');
    row.className = 'summary-row';
    row.style = `
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 8px;
      font-size: 14px;
    `; 

    // Display index
    const stepIndex = document.createElement('span');
    stepIndex.textContent = `${displayIndex++}.`;
    stepIndex.style = 'width: 24px; font-weight: 600; text-align: center;';
    row.appendChild(stepIndex);

    // Label + value
    const labelValWrap = document.createElement('div');
    labelValWrap.style = 'flex: 1; display: flex; justify-content: space-between; align-items: center; gap: 10px;';

    const label = document.createElement('span');
    label.textContent = s.querySelector('h3')?.textContent?.trim() || `Step ${stepNum}`;
    label.style = 'font-weight: 500; flex: 1;';
    labelValWrap.appendChild(label);

    const value = document.createElement('span');
    value.textContent = values[0]?.value || '(empty)';
    value.style = 'color: #333; min-width: 60px; text-align: right;';
    labelValWrap.appendChild(value);

    row.appendChild(labelValWrap);

    // Edit button
    const edit = document.createElement('div');
    edit.textContent = 'Edit';
    edit.className = 'edit_button';
    edit.style = `
      margin-left: 10px;
      padding: 0px 8px;
      cursor: pointer;
    `;
    
    // Use existing showStep function to go back to that step
    edit.addEventListener('click', () => {
      showStep(idx); // redirects to the correct step
    });

    row.appendChild(edit);

    list.appendChild(row);
  });

  // Add Review Note as last step if exists
  const reviewInput = modal.querySelector('#reviewNote');
  if (reviewInput && reviewInput.value.trim() !== '') {
    const row = document.createElement('div');
    row.className = 'summary-row';
    row.style = `
      display: flex;
      align-items: start;
      justify-content: space-between;
      padding: 5px 8px;
      font-size: 14px;
    `;

    const stepIndex = document.createElement('span');
    stepIndex.textContent = `${displayIndex++}.`;
    stepIndex.style = 'width: 24px; font-weight: 600; text-align: center;';
    row.appendChild(stepIndex);

    const labelValWrap = document.createElement('div');
    labelValWrap.style = 'flex: 1; display: flex; justify-content: space-between; align-items: start; gap: 10px;';

    const label = document.createElement('span');
    label.textContent = 'Review Note';
    label.style = 'font-weight: 500; flex: 1;';
    labelValWrap.appendChild(label);

    const value = document.createElement('span');
    value.textContent = reviewInput.value.trim();
    value.style = 'color: #333; min-width: 60px; text-align: right;';
    labelValWrap.appendChild(value);

    row.appendChild(labelValWrap);

    const edit = document.createElement('div');
    edit.textContent = 'Edit';
    edit.className = 'edit_button';
    edit.style = `
      margin-left: 10px;
      padding: 0px 8px;
      cursor: pointer;
    `;
    edit.addEventListener('click', () => {
      const reviewStepIdx = steps.findIndex(s => s.dataset.role === 'review');
      if (reviewStepIdx >= 0) showStep(reviewStepIdx);
    });

    row.appendChild(edit);
    list.appendChild(row);
  }

  // Enable save only if all steps are valid
  const saveBtn = summaryEl.querySelector('[data-action="save"]');
  if (saveBtn) saveBtn.disabled = !areAllDataStepsValid();
}




  /* ---------- copy modal values into product form ---------- */
  function copyModalValuesToProductForm() {
    try {
      const modalEl = document.querySelector(MODAL_SELECTOR);
      if (!modalEl) return false;

      const productFormId = modalEl.getAttribute('data-product-form-id');
      const productForm = productFormId ? document.getElementById(productFormId) : document.querySelector('form.product-form, form[data-product-form]');
      if (!productForm) {
        console.warn('Product form not found for modal.');
        return false;
      }

      // remove previously injected hidden inputs
      productForm.querySelectorAll('[data-injected-by="modal"]').forEach(el => el.remove());

      // gather modal inputs (inputs, textareas, selects)
      const inputs = Array.from(modalEl.querySelectorAll('input[name], textarea[name], select[name]'));

      inputs.forEach(inp => {
        const name = inp.getAttribute('name');
        if (!name) return;

        // create hidden input inside product form with same name & value
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = name;
        if (inp.type === 'checkbox' || inp.type === 'radio') {
          hidden.value = inp.checked ? (inp.value || 'true') : '';
        } else {
          hidden.value = inp.value ?? '';
        }
        hidden.setAttribute('data-injected-by', 'modal');

        productForm.appendChild(hidden);
      });

      // enable add to cart if present
      const addBtn = productForm.querySelector('[data-product-add-to-cart-button], #AddToCart, button[type="submit"]');
      if (addBtn) addBtn.disabled = false;

      return true;
    } catch (err) {
      console.error('Error copying modal values to product form', err);
      return false;
    }
  }

  /* ---------- Wiring radio custom open ---------- */
  document.addEventListener('change', function (e) {
    const el = e.target;
    if (!el.matches(RADIO_SELECTOR) || !el.checked) return;
    if (el.dataset.custom === 'true') {
      openModal(el);
    } else {
      closeModal(true);
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-close]')) { e.preventDefault(); closeModal(false); }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !$(MODAL_SELECTOR)?.hidden) closeModal(false);
  });

  document.addEventListener('DOMContentLoaded', () => {
    const pre = $(`${RADIO_SELECTOR}[data-custom="true"]:checked`);
    if (pre) openModal(pre);
  });

  // expose for debugging if needed
  window.openMeasurementModal = openModal;

  

/* ---------- Progress Bar ---------- */
function updateProgressBar() {
  if (!steps || steps.length === 0) return;

  // Count ALL steps including intro, review, and summary
  const totalSteps = steps.length;

  // Calculate progress as current step index (starting from 0)
  let percent = ((currentStep + 1) / totalSteps) * 100;

  // Clamp just in case
  if (!Number.isFinite(percent) || percent < 0) percent = 0;
  if (percent > 100) percent = 100;

  // Update the bar and text
  const bar = document.getElementById('progress-bar');
  const barText = document.getElementById('progress-bar');

  if (bar) bar.style.width = `${percent}%`;
  if (barText) barText.textContent = `${Math.round(percent)}%`;
}

function selectDefaultSize() {
  const label = document.querySelector('.block-swatch__item.variant-Unstitched') || document.querySelector('.block-swatch__item.variant-Semi');
  if (!label) return;

  const forId = label.getAttribute('for');
  if (!forId) return;

  const radio = document.getElementById(forId);
  if (!radio) return;

  radio.checked = true;
  radio.dispatchEvent(new Event('change', { bubbles: true }));
}




})();


// Remove overflow from body when model is open
const modal = document.getElementById('customModal');

const observer = new MutationObserver(() => {
  document.body.style.overflow = modal.hasAttribute('hidden') ? '' : 'hidden';
  document.body.style.paddingRight = modal.hasAttribute('hidden') ? '' : '14px';
});

observer.observe(modal, { attributes: true, attributeFilter: ['hidden'] });










